/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum MiddlewareSteps {
    Prepare = 'prepare',
    Run = 'run',
    HandleResponse = 'handleResponse',
    HandleErrors = 'handleErrors',
}
